import React, { useEffect, useState } from 'react';
import './header.scss';
import tournaments from '../../assets/tournaments.json';

const Header = (props) => {
    let [allTournaments, setAllTournaments] = useState([]);

    useEffect(() => {
        if(allTournaments.length === 0) {
            const getTournaments = tournaments.Tournaments.map(item => item);
    
            setAllTournaments(getTournaments);
        }
    });

    return [
        <header className="sports-header">
            <nav className="navbar navbar-expand-lg bg-body-tertiary border-bottom">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">Hockey</a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div className="navbar-nav">
                            <a className="nav-link active" aria-current="page" href="#">Dashboard</a>
                            {/* <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Tournaments
                                </a>
                                <ul className="dropdown-menu">
                                    { allTournaments.map(t => (<li><a className="dropdown-item" href="#">{ t.Name }</a></li>)) }
                                </ul>
                            </li> */}
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    ];
};

export default Header;